<h3 mat-dialog-title>{{ title }}</h3>

<mat-dialog-content>
    <form [formGroup]="form">
        <div class="form-group">
            <label>
                {{ contextNoun }} Title
            </label>
            <div class="balance-input">
                <input class="w-100 form-control form-control-sm" formControlName="label" type="text"/>
            </div>
            <lf-control-messages [control]="form.controls['label']"></lf-control-messages>
        </div>

        <div *ngIf="!isAccountsReceivable && !isNetIncome" class="row">
            <div class="col-md-6">
                <label>
                    Starting Balance
                </label>
                <div class="balance-input">
                    <lf-currency [showSymbol]="true"
                                 formControlName="startingBalance"
                                 validateDecimal></lf-currency>
                </div>
                <lf-control-messages [control]="form.controls['startingBalance']"></lf-control-messages>
            </div>
            <div class="col-md-6 form-group">
                <label>
                    Balance as of
                </label>

                <input
                    (click)="asOfDate.open()"
                    [matDatepicker]="asOfDate"
                    class="form-control date d-inline-block"
                    color="accent"
                    formControlName="asOf"
                    placeholder="Start date..."
                />
                <mat-datepicker #asOfDate></mat-datepicker>
                <lf-control-messages [control]="form.controls['asOf']"></lf-control-messages>
            </div>
        </div>

        <div *ngIf="isAccountsReceivable" class="mt-3 p-3 bg-light text-danger text-center mx-auto" style="border-radius: 4px; max-width: 80%;">
            {{ accountsReceivableMessage }}
        </div>

        <div *ngIf="isNetIncome" class="mt-3 p-3 bg-light text-danger text-center mx-auto" style="border-radius: 4px; max-width: 80%;">
            {{ netIncomeMessage }}
        </div>

        <div *ngIf="isRetainedEarnings" class="mt-3 p-3 bg-light text-center mx-auto" style="border-radius: 4px; max-width: 80%;">
            {{ retainedEarningsMessage }}
        </div>

        <div *ngIf="form.contains('useLikeBankAccount')" class="mt-3">
            <mat-checkbox class="mr-3" formControlName="useLikeBankAccount" matTooltip="Creates a bank account placeholder tied to this asset that can be used for recording transactions and transfers.">
                Use Like a Bank Account
            </mat-checkbox>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>Cancel</button>
    <button (click)="save()" [disabled]="!form.valid || submitInFlight" class="btn btn-primary">
        <span *ngIf="!data.create">Save {{ contextNoun }}</span>
        <span *ngIf="data.create">Add {{ contextNoun }}</span>
    </button>
</mat-dialog-actions>
